import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Product from "./pages/Product";
import Media from "./pages/Media";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Urbangro from "./pages/urbangro";
import Healthcare from "./pages/healthcare";
import favicon from "./assets/AI7.jpg";

const App = () => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.title = "Algebracorp | Building Digital Products";
      let link: HTMLLinkElement | null =
      document.querySelector("link[rel='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = favicon;
    }
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/product" element={<Product />} />
        <Route path="/media" element={<Media />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/urbangro" element={<Urbangro />} />
        <Route path="/healthcare" element={<Healthcare />} />
      </Routes>
    </Router>
  );
};

export default App;
